import { useState } from "react";
import { Link } from "react-router-dom";
import { PublicShell } from "@/components/PublicShell";
import { LeadForm } from "@/components/LeadForm";
import { RoiCalculator } from "@/components/RoiCalculator";
import { Seo } from "@/components/Seo";

const PHASES = [
  ["Weeks 1–3 · Connect", "Map your internal registers and connect enterprise systems (ITSM, ERP)."],
  ["Weeks 4–6 · Sense", "Wire live intelligence feeds and map your top 25 high-risk suppliers, n-tier."],
  ["Weeks 7–9 · Quantify", "Quantify your top 10 material exposures in £ and model three named scenarios."],
  ["Weeks 10–12 · Prove", "Deliver a board pack and a fully replayable assurance trail."],
];

export default function BookPilot() {
  const [roiSummary, setRoiSummary] = useState("");
  return (
    <PublicShell active="/pilot">
      <Seo title="Book an ERIO Design-Partner Pilot — EKSELENS" path="/pilot"
        description="Scope an 8–12 week ERIO design-partner pilot — board-ready value in a single quarter." />
      <section className="mx-auto grid max-w-6xl gap-12 px-6 py-16 lg:grid-cols-2 lg:items-start">
        <div>
          <span className="text-xs font-semibold uppercase tracking-wider text-ek-purple">Book a pilot</span>
          <h1 className="mt-3 text-4xl font-semibold tracking-tight sm:text-5xl">Board-ready value in a single quarter.</h1>
          <p className="mt-4 text-base text-ek-ink/70">
            A tightly-scoped, fixed-fee design-partner pilot that proves the value on your own data — without
            disrupting operations.
          </p>
          <div className="mt-8 space-y-4">
            {PHASES.map(([t, b]) => (
              <div key={t} className="border-l-2 border-ek-purple pl-4" data-testid="pilot-phase">
                <p className="text-sm font-semibold text-ek-ink">{t}</p>
                <p className="mt-0.5 text-sm text-ek-ink/65">{b}</p>
              </div>
            ))}
          </div>
          <p className="mt-8 text-sm text-ek-ink/70">
            Want the detail first? <Link to="/brief" className="font-semibold text-ek-purple hover:underline">Read the executive brief →</Link>
          </p>
        </div>
        <div className="rounded-2xl border border-black/5 bg-white p-7 shadow-sm lg:p-8">
          <h2 className="text-lg font-semibold">Scope your pilot</h2>
          <p className="mt-1 mb-5 text-sm text-ek-ink/70">Share a little context and we'll arrange a 45-minute scoping call.</p>
          <LeadForm kind="pilot" source="book-pilot-page" appendMessage={roiSummary}
            messagePlaceholder="What outcomes would make this pilot a success for you?" />
        </div>
      </section>
      <RoiCalculator onSummary={setRoiSummary} />
    </PublicShell>
  );
}
